import React from 'react'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi'
import { GrPrevious } from 'react-icons/gr'
import { GrNext } from 'react-icons/gr'
import { Link } from 'react-router-dom'
import constr from '../Components/images/sale/constr.jpg'
import construction from '../Components/images/sale/construction.jpg'
import cylander from '../Components/images/sale/cylander.jpg'
import hdesert from '../Components/images/sale/hdesert.jpg'
import beach from '../Components/images/sale/beach.jpg'
import bech from '../Components/images/sale/bech.jpg'
import tick from '../Components/images/tick.png'
import pic5 from '../Components/images/ourteam/pic5.jpg'
import pic2 from '../Components/images/ourteam/pic2.jpg'
import { ImLocation2 } from 'react-icons/im';
import feature1 from '../Components/images/feature1.jpg'
import feature2 from '../Components/images/feature2.jpg'
import feature3 from '../Components/images/feature3.jpg'

function ShowPrevArrow(props) {
    const { onClick } = (props)
    return (

        < div
            onClick={onClick} className='block  absolute md:text-[2.5rem] text-[1.3rem] md:text-[#b5d1b3] text-white md:top-12 bottom-8  md:left-[-4rem] cursor-pointer   z-10 hover:text-[#004a8b]'>< GrPrevious />
        </div >


    )
}

function ShowNextArrow(props) {
    const { onClick } = (props)
    return (

        < div
            onClick={onClick} className='block  absolute md:text-[2.5rem] text-[1.3rem] md:top-12 bottom- right-5 md:right-[-4rem] z-10  cursor-pointer' > < GrNext className='md:text-[#b5d1b3] text-white hover:text-[#004a8b]' />
        </div >


    )
}


const Sliders = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        prevArrow: <ShowPrevArrow />,
        nextArrow: <ShowNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };

    return (
        <>

            <div className="container-fluid mx-3 md:mx-10">

                <div className="flex md:flex-col flex-col-reverse">

                    <div className="grid md:grid-cols-12">

                        <div className="col-span-5 bg-[#004A8B]">
                            <div className="">
                                <div className="flex mx-[1.2rem] md:mx-[3rem]   ">
                                    <Link to='/ForSale'><HiOutlineArrowNarrowLeft className='text-white md:block hidden text-[2rem] my-[1rem] ' /></Link>
                                    <div className='text-[12px]  md:mx-20 px-10 py-5 bg-[#B5D1B3] text-white '>
                                        <h1 className='text-center py-[.2rem]'>EOI</h1>
                                        <h1 className='border-b-4 w-[3.3rem]  border-b-white'></h1>
                                    </div>
                                </div>

                                <div className="pt-10 my-7 px-7 md:px-20">
                                    <h1 className='text-white text-[2rem] tracking-wider font-black'>FITZROY</h1>
                                    <h1 className='text-white text-[2rem] tracking-wider font-black'>MACADAMIAS</h1>
                                    <h1 className='border-b-[.4rem] border-b-[#B5D1B3] py-2 w-[4rem]'></h1>
                                    <h1 className='text-white py-4 flex'><span className='font-bold  text-[13px]'>PRICE</span> <span className='mx-[5rem]'>EOI</span></h1>
                                    <h1 className='text-white  flex'><span className='font-bold  text-[13px]'>SIZE</span> <span className='mx-[5.7rem]'>590</span></h1>
                                </div>

                            </div>
                        </div>

                        <div className="md:col-span-7 md:block hidden">
                            <img src={constr} alt="" className='md:w-full md:h-[60vh]' />
                        </div>

                    </div>

                    <div className='md:py-4   md:mx-20'>

                        <Slider {...settings}>

                            <div className='md:px-2'>
                                <img src={beach} />
                            </div>
                            <div className='md:px-2'>
                                <img src={bech} />
                            </div>
                            <div className='md:px-2'>
                                <img src={constr} />
                            </div>
                            <div className='md:px-2'>
                                <img src={construction} />
                            </div>
                            <div className='md:px-2'>
                                <img src={cylander} />
                            </div>
                            <div className='md:px-2'>
                                <img src={hdesert} />
                            </div>
                        </Slider>
                    </div>

                </div>
                <div className="md:bg10 md:relative ">

                    <div className="grid md:grid-cols-12 md:gap-15 md:mx-20 md:my-10 md:relative ">

                        <div className="md:col-span-5">
                            <div className="">
                                <h1 className='text-[1.5rem] font-black tracking-wider text-[#004A8B]'>Byangle, 1721 Wee Jasper</h1>
                                <h1 className='text-[1.5rem] font-black tracking-wider text-[#004A8B]'>Road,</h1>
                                <h1 className='text-[1.5rem] font-black tracking-wider text-[#004A8B]'> TUMUT NSW 2720</h1>
                                <h1 className='text-[1.5rem] py-5 font-black tracking-wider text-[#004A8B]'>Feature</h1>
                                <h1 className='flex'><img src={tick} alt="" /><span className='py-1 mx-2'>4 bed</span></h1>
                                <h1 className='flex'><img src={tick} alt="" /><span className='py-1 mx-2'>Land is 91 ha</span></h1>
                            </div>
                        </div>

                        <div className="md:col-span-7  z-10 ">
                            <p className='trancking-wider leading-7'>LAWD is pleased to present for sale Byangle (The Property). A rural lifestyle property comprising 91* hectares (224* acres) with genuine income earning capacity given its scale and production capabilities. Situated in a 752.4* millimetre rainfall zone, in the South West Slopes of New South Wales.</p>

                            <p className='trancking-wider leading-7 py-4'>Highly suited to both sheep and cattle enterprises, with a combination of improved perennial and native perennial grass and clover pastures.</p>

                            <p className='trancking-wider leading-7 py-4'>LAWD is pleased to present for sale Byangle (The Property). A rural lifestyle property comprising 91* hectares (224* acres) with genuine income earning capacity given its scale and production capabilities. Situated in a 752.4* millimetre rainfall zone, in the South West Slopes of New South Wales.</p>

                            <p className='trancking-wider leading-7 py-4'>Highly suited to both sheep and cattle enterprises, with a combination of improved perennial and native perennial grass and clover pastures.</p>

                            <p className='trancking-wider leading-7 py-4'>LAWD is pleased to present for sale Byangle (The Property). A rural lifestyle property comprising 91* hectares (224* acres) with genuine income earning capacity given its scale and production capabilities. Situated in a 752.4* millimetre rainfall zone, in the South West Slopes of New South Wales.</p>


                            <p className='trancking-wider leading-7 py-4'>Highly suited to both sheep and cattle enterprises, with a combination of improved perennial and native perennial grass and clover pastures.</p>


                            <div className="py-5">
                                <div className="py-10">
                                    <h1 className='text-[#004A8B] text-[2.2rem] py-2 font-black border-b-[.4rem] border-b-[#B5D1B3] w-[3.4rem]'><span className=''>Agents</span></h1>
                                </div>
                                <div className="md:flex gap-5 ">
                                    <div className="w-full">
                                        <div className="relative">
                                            <img src={pic5} alt="" className='w-full' />
                                            <span className='absolute   h-full w-full overflow-hidden bg-[rgba(0,74,139,0.6)]  top-0 left-0'>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-full md:py-0 py-5">
                                        <div className="relative">
                                            <img src={pic2} alt="" className='w-full' />
                                            <span className='absolute   h-full w-full overflow-hidden bg-[rgba(0,74,139,0.6)]  top-0 left-0'>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="py-6">
                    <div className=""><h1 className='md:text-4xl text-3xl py-10 md:mx-20 mx-5  font-black text-[#004A8B]'>Similar Listing</h1>
                    </div>
                    <div className=" border-b-8 border-b-[#B5D1B3] mt-[-2rem] w-[4rem] mx-5 md:mx-20"></div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 mx-2 py-4 md:mx-20 md:grid-cols-3 gap-4">

                    <div class="">
                        <div className="group relative">
                            <a href="/Slider">
                                <h1 className='mx-[10px] my-[10px] text-sm absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[10px] py-[5px] text-center justify-center'>EOI</h1>
                                <img src={feature1} alt="feature1" />

                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-sm font-black text-[#00498A]'>BOWEN</h1>
                        </div>
                        <div className="my-1 mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="my-1 mx-1 text-gray-400 font-bold"><h1>1223 ha</h1></div>
                    </div>

                    <div class="">
                        <div className="group relative">
                            <a href="/Slider">
                                <h1 className='mx-[10px] my-[10px] text-sm absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[10px] py-[5px] text-center justify-center'>EOI</h1>
                                <img src={feature2} alt="feature1" />

                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-sm font-black text-[#00498A]'>GRIFFITH</h1>
                        </div>
                        <div className="my-1 mx-1 font-black"><h1>1632 Rankins Springs Road</h1></div>
                        <div className="my-1 mx-1 text-gray-400 font-bold"><h1>151 ha</h1></div>
                    </div>

                    <div class="">
                        <div className="group relative">
                            <a href='/Slider'>
                                <h1 className='mx-[10px] my-[10px] text-sm absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[10px] py-[5px] text-center justify-center'>EOI</h1>
                                <img src={feature3} alt="feature1" />

                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-sm font-black text-[#00498A]'>RYANSBROOK</h1>
                        </div>
                        <div className="my-1 mx-1 font-black"><h1>139 Douglas Road</h1></div>
                        <div className="my-1 mx-1 text-gray-400 font-bold"><h1>8554 ha</h1></div>
                    </div>

                </div>


            </div>
        </>
    )
}

export default Sliders